import { msg_are_you_sure, msg_no, msg_yes } from "@dvrt/graphql-widgets";
import { Button, Dialog, DialogActions, DialogContent, Typography } from "@mui/material";
import { FormattedMessage, MessageDescriptor } from "react-intl";

type MessageValues = { [key: string]: any };

type Props = {
    onConfirm: () => void;
    onCancel?: () => void;
    close: () => void;
    isOpen: boolean;
    message?: MessageDescriptor;
    messageVars?: MessageValues;
};

const ConfirmDialog = ({ onConfirm, onCancel, isOpen, close, message, messageVars }: Props) => {
    function confirm() {
        close();
        onConfirm();
    }

    function cancel() {
        close();
        onCancel?.();
    }

    return (
        <Dialog
            open={isOpen}
            onClose={(reason) => {
                if (reason !== "backdropClick") close();
            }}
        >
            <DialogContent style={{ padding: "1.5em" }}>
                <Typography>
                    <FormattedMessage {...(message ?? msg_are_you_sure)} values={messageVars} />
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={confirm} color="primary">
                    <FormattedMessage {...msg_yes} />
                </Button>
                <Button onClick={cancel} color="secondary">
                    <FormattedMessage {...msg_no} />
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
